import { render, staticRenderFns } from "./PostMeta.vue?vue&type=template&id=1495c9a2&"
import script from "./PostMeta.vue?vue&type=script&lang=ts&"
export * from "./PostMeta.vue?vue&type=script&lang=ts&"
import style0 from "./PostMeta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports